import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { DASHBOARD_ENTITLEMENTS } from '../../../utils/printerStatus';
import {
  EntitlementState,
  hasEntitlementsForEntitlements,
  hasOfferingsForEntitlements,
} from '../../../utils/entitlementHelpers';

const INSTANT_INK_ENTITLEMENTS = [DASHBOARD_ENTITLEMENTS.instantInk, DASHBOARD_ENTITLEMENTS.printPlans];

export const useInstantInkSubscriptionCounters = ({ devicesProgramInfos, grantsCall }) => {
  const flags = useFlags();

  const {
    grantsSupport,
  } = flags;

  const instantInkCounters = useMemo(() => {
    let instantInkEligiblePrinterCounter = 0;
    let instantInkEnrolledPrinterCounter = 0;

    const devicesWithProgramInfo = devicesProgramInfos || [];
    const grantsByDeviceId = grantsCall || {};

    devicesWithProgramInfo.forEach(deviceProgramInfo => {
      const programInfo = deviceProgramInfo?.programInfo || {};
      const grants = grantsByDeviceId?.[deviceProgramInfo?.deviceId];

      if (grantsSupport) {
        if (INSTANT_INK_ENTITLEMENTS.some(entitlement => grants?.[entitlement])) {
          instantInkEligiblePrinterCounter += 1;
          instantInkEnrolledPrinterCounter += 1;
        } else if (hasOfferingsForEntitlements(programInfo, INSTANT_INK_ENTITLEMENTS)) {
          instantInkEligiblePrinterCounter += 1;
        }
      } else if (INSTANT_INK_ENTITLEMENTS.some(entitlement => hasEntitlementsForEntitlements(
        programInfo,
        [entitlement],
        [EntitlementState.Enabled, EntitlementState.Pending],
      ))) {
        instantInkEligiblePrinterCounter += 1;
        instantInkEnrolledPrinterCounter += 1;
      } else if (hasOfferingsForEntitlements(programInfo, INSTANT_INK_ENTITLEMENTS)) {
        instantInkEligiblePrinterCounter += 1;
      }
    });

    return {
      instantInkEligiblePrinterCounter,
      instantInkEnrolledPrinterCounter,
    };
  }, [devicesProgramInfos, grantsCall, grantsSupport]);

  return instantInkCounters;
};

export default useInstantInkSubscriptionCounters;
